// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AktuellesRouteImport } from './routes/aktuelles'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as LeistungenRouteImport } from './routes/leistungen'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as UeberUnsRouteImport } from './routes/ueber-uns'
import { Route as AktuellesSlugRouteImport } from './routes/aktuelles_.$slug'
import { Route as LeistungenServiceRouteImport } from './routes/leistungen_.$service'
import { Route as RegionenRegionRouteImport } from './routes/regionen.$region'
import { Route as LeistungenServiceOrtRouteImport } from './routes/leistungen_.$service_.$ort'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AktuellesRoute = AktuellesRouteImport.update({
            id: '/aktuelles',path: '/aktuelles',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const LeistungenRoute = LeistungenRouteImport.update({
            id: '/leistungen',path: '/leistungen',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const UeberUnsRoute = UeberUnsRouteImport.update({
            id: '/ueber-uns',path: '/ueber-uns',getParentRoute: () => rootRouteImport
          })
const AktuellesSlugRoute = AktuellesSlugRouteImport.update({
            id: '/aktuelles_/$slug',path: '/aktuelles/$slug',getParentRoute: () => rootRouteImport
          })
const LeistungenServiceRoute = LeistungenServiceRouteImport.update({
            id: '/leistungen_/$service',path: '/leistungen/$service',getParentRoute: () => rootRouteImport
          })
const RegionenRegionRoute = RegionenRegionRouteImport.update({
            id: '/regionen/$region',path: '/regionen/$region',getParentRoute: () => rootRouteImport
          })
const LeistungenServiceOrtRoute = LeistungenServiceOrtRouteImport.update({
            id: '/leistungen_/$service_/$ort',path: '/leistungen/$service/$ort',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AktuellesRoute: AktuellesRoute,DatenschutzRoute: DatenschutzRoute,FaqRoute: FaqRoute,ImpressumRoute: ImpressumRoute,KontaktRoute: KontaktRoute,LeistungenRoute: LeistungenRoute,SitemapRoute: SitemapRoute,UeberUnsRoute: UeberUnsRoute,AktuellesSlugRoute: AktuellesSlugRoute,LeistungenServiceRoute: LeistungenServiceRoute,RegionenRegionRoute: RegionenRegionRoute,LeistungenServiceOrtRoute: LeistungenServiceOrtRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)